import * as React from 'react';
import { connect } from 'react-redux';
import { INotification, INotificationType } from './business-objects/common';
import { Form, Button } from 'react-bootstrap';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import {
  convertToRaw,
  EditorState,
  Modifier,
  RichUtils,
  ContentState,
  convertFromHTML,
} from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import * as _ from 'lodash';
import LookupValueSelectList from '../LookupValueSelectList/LookupValueSelectList';
import { LookupValueTypes } from '../LookupValueSelectList/lookupValueTypes';

interface INotificationEditFormState {
  notificationTypes: INotificationType[];
  Types: INotificationType[];
}

interface INotificationEditFormOwnProps {
  notificationToEdit: INotification;
}

interface INotificationEditFormLocalState {
  [key: string]: EditorState;
  current: INotification;
  headerStatus: eHeaderSignatureStatus;
  signatureStatus: eHeaderSignatureStatus;
}

enum eHeaderSignatureStatus {
  No = 1,
  UseExisting,
  CreateNew,
}

enum eNotificationType {
  Email = 1,
  Postal,
  Both,
}

interface INotificationEditFormProps
  extends INotificationEditFormOwnProps,
    INotificationEditFormState {}

export class NotificationEditForm extends React.Component<
  INotificationEditFormProps,
  INotificationEditFormLocalState
> {
  constructor(props) {
    super(props);
    this.state = {
      current: null,
      headerStatus: eHeaderSignatureStatus.No,
      signatureStatus: eHeaderSignatureStatus.No,
    };
  }

  componentWillMount() {
    //console.log('editing', this.props.notificationToEdit);
    this.setState(
      {
        current: {
          ..._.cloneDeep(this.props.notificationToEdit),
          notificationType: this.props.notificationTypes.find(
            (item) => item.id == 1
          ),
        },
      },
      () => {
        let curBodyState =
          this.state.current.body != undefined
            ? this.getEditorStateFromHTML(this.state.current.body)
            : EditorState.createEmpty();
        this.setState({
          editorState: curBodyState,
          current: { ...this.state.current },
        });
      }
    );
  }

  getUpdatedNotification = () => this.state.current;

  handleChange = (e: React.FormEvent) => {
    let el: HTMLFormElement = e.currentTarget as HTMLFormElement;
    let notificationTypeValue: number = this.state.current.notificationType.id;

    switch (el.dataset.field) {
      case 'subject':
        this.setState({
          current: { ...this.state.current, subject: el.value },
        });
        break;
      case 'description':
        this.setState({
          current: { ...this.state.current, description: el.value },
        });
        break;
      case ' name':
        this.setState({ current: { ...this.state.current, name: el.value } });
        break;
      case 'send from':
        this.setState({
          current: { ...this.state.current, sendFrom: el.value },
        });
        break;
      case 'send to':
        this.setState({
          current: { ...this.state.current, sendTo: el.value },
        });
        break;
      default:
        break;
    }
  };

  getEditorStateFromHTML = (htmlString: string) => {
    const blocksFromHTML = convertFromHTML(htmlString);
    return EditorState.createWithContent(
      ContentState.createFromBlockArray(
        blocksFromHTML.contentBlocks,
        blocksFromHTML.entityMap
      )
    );
  };

  onBodyEditorStateChange = (editorBodyState: EditorState) => {
    let editorHTML = draftToHtml(
      convertToRaw(editorBodyState.getCurrentContent())
    );
    this.setState({
      editorState: editorBodyState,
      current: { ...this.state.current, body: editorHTML },
    });
  };

  handleTab = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();

    let editorDescriptorElement = ((e.currentTarget as HTMLDivElement)
      .children[0] as HTMLDivElement).children[0] as HTMLDivElement;
    let currentState = EditorState.createEmpty();
    let targetStateKey = '';

    if (editorDescriptorElement.dataset.editor == 'eBody')
      targetStateKey = 'editorState';
    else if (editorDescriptorElement.dataset.editor == 'eHeader')
      targetStateKey = 'headerEditorState';
    else targetStateKey = 'signatureEditorState';
    currentState = this.state[targetStateKey];

    const selection = currentState.getSelection();
    const blockType = currentState
      .getCurrentContent()
      .getBlockForKey(selection.getStartKey())
      .getType();

    if (
      blockType === 'unordered-list-item' ||
      blockType === 'ordered-list-item'
    ) {
      this.setState({ [targetStateKey]: RichUtils.onTab(e, currentState, 3) });
    } else {
      let newContentState = Modifier.insertText(
        currentState.getCurrentContent(),
        currentState.getSelection(),
        '    '
      );

      this.setState({
        [targetStateKey]: EditorState.push(
          currentState,
          newContentState,
          'insert-characters'
        ),
      });
    }
  };

  handleChangeNotificationType = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = event.target.value;
    //console.log(this.state);
    this.setState({
      current: {
        ...this.state.current,
        notificationTypeId: value,
      },
    });
  };

  render() {
    return (
      <Form>
        <Form.Group controlId='NotificationType'>
          <Form.Label>
            <strong>Letters Type</strong>
          </Form.Label>
          <LookupValueSelectList
            onChange={this.handleChangeNotificationType}
            value={this.state.current.notificationTypeId}
            type={LookupValueTypes.NOTIFICATION_TYPES}
            includeAll={false}
          />
        </Form.Group>

        <Form.Group controlId='Subject'>
          <Form.Label>
            <strong>Subject</strong>
          </Form.Label>
          <Form.Control
            type='text'
            data-field='subject'
            placeholder='Enter notification  subject...'
            onChange={this.handleChange}
            value={this.state.current != null ? this.state.current.subject : ''}
          />
        </Form.Group>

        <Form.Group controlId='SendFrom'>
          <Form.Label>
            <strong>Send From</strong>
          </Form.Label>
          <Form.Control
            type='text'
            data-field='send from'
            placeholder='Enter who to send from...'
            onChange={this.handleChange}
            value={
              this.state.current != null
                ? this.state.current.sendFrom != null
                  ? this.state.current.sendFrom
                  : ''
                : ''
            }
          />
        </Form.Group>

        <Form.Group controlId='SendTo'>
          <Form.Label>
            <strong>Send To</strong>
          </Form.Label>
          <Form.Control
            as='input'
            type='text'
            data-field='send to'
            placeholder='Enter who to send to...'
            onChange={this.handleChange}
            value={this.state.current != null ? this.state.current.sendTo : ''}
          />
        </Form.Group>

        <Form.Group controlId='Body'>
          <Form.Label>
            <strong>Body Content</strong>
          </Form.Label>
          <Editor
            wrapperClassName='wrapper-class'
            editorClassName='editor-class'
            onEditorStateChange={this.onBodyEditorStateChange}
            spellCheck={true}
            onTab={this.handleTab}
            editorKey='eBody'
            editorState={this.state.editorState}
            placeholder='Enter body content ...'
            toolbarHidden={false}
            toolbar={{
              options: [
                'inline',
                'blockType',
                'fontSize',
                'fontFamily',
                'list',
                'textAlign',
                'link',
                'image',
                'remove',
                'history',
              ],
            }}
            data-field='body editor'
          />
        </Form.Group>
      </Form>
    );
  }
}

const mapStateToProps = (reduxState: any) => {
  //console.log('mapping', reduxState);
  return {
    notificationTypes: reduxState.qnotification.notificationTypes,
  };
};

export default connect<INotificationEditFormState, any>(
  mapStateToProps,
  {},
  null,
  { forwardRef: true }
)(NotificationEditForm);
